"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.eventsEvalFilterColumns = exports.observationEvalFilterColumns = void 0;
exports.observationEvalFilterColsWithOptions = observationEvalFilterColsWithOptions;
const typeHelpers_1 = require("../../tableDefinitions/typeHelpers");
const filterFields_1 = require("./filterFields");
const experimentFilters_1 = require("./experimentFilters");
exports.observationEvalFilterColumns = [
    filterFields_1.evalFilterFields.type,
    filterFields_1.evalFilterFields.name,
    filterFields_1.evalFilterFields.environment,
    filterFields_1.evalFilterFields.level,
    filterFields_1.evalFilterFields.version,
    filterFields_1.evalFilterFields.release,
    filterFields_1.evalFilterFields.statusMessage,
    filterFields_1.evalFilterFields.providedModelName,
    filterFields_1.evalFilterFields.promptName,
    filterFields_1.evalFilterFields.promptVersion,
    filterFields_1.evalFilterFields.traceName,
    filterFields_1.evalFilterFields.userId,
    filterFields_1.evalFilterFields.sessionId,
    filterFields_1.evalFilterFields.tags,
    filterFields_1.evalFilterFields.metadata,
    filterFields_1.evalFilterFields.isRootObservation,
    filterFields_1.evalFilterFields.parentObservationId,
    filterFields_1.evalFilterFields.experimentId,
    filterFields_1.evalFilterFields.experimentName,
    filterFields_1.evalFilterFields.isExperimentItemRootSpan,
    filterFields_1.evalFilterFields.calledToolNames,
    filterFields_1.evalFilterFields.toolCalls,
];
exports.eventsEvalFilterColumns = [
    ...exports.observationEvalFilterColumns,
    ...experimentFilters_1.experimentEvalFilterColumns,
];
function observationEvalFilterColsWithOptions(options, cols = exports.observationEvalFilterColumns) {
    return cols.map((col) => {
        if (col.id === "environment") {
            return (0, typeHelpers_1.formatColumnOptions)(col, options?.environment ?? []);
        }
        if (col.id === "tags") {
            return (0, typeHelpers_1.formatColumnOptions)(col, options?.tags ?? []);
        }
        if (col.id === "traceName") {
            return (0, typeHelpers_1.formatColumnOptions)(col, options?.traceName ?? []);
        }
        if (col.id === "name") {
            return (0, typeHelpers_1.formatColumnOptions)(col, options?.name ?? []);
        }
        if (col.id === "calledToolNames") {
            return (0, typeHelpers_1.formatColumnOptions)(col, options?.calledToolNames ?? []);
        }
        return col;
    });
}
